import React, { useState, useEffect } from "react";
import useMediaQuery from "../Hooks/useMediaQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "../../assets/css/expando.css";
import NonBreakingSpace from "./NonBreakingSpace";

export function Expando(props) {
  const { deviceScreen } = useMediaQuery();
  const isMobile = ["x-small", "small"].includes(deviceScreen);
  const {
    children,
    thumbnailUrl = "",
    name = "",
    collapsedText = "View",
    expandedText = "Collapse",
    setExpandoStatusCallback = () => {},
    sectionRef,
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setExpandoStatusCallback(isOpen);
  }, [isOpen]);

  //collapsed
  if (isMobile && !isOpen) {
    return (
      <div
        onClick={() => setIsOpen(true)}
        className="profile-box expando-collapsed"
      >
        <div className="expando-grid">
          <div>
            <img
              className="expando-image child-photo--thumbnail"
              src={thumbnailUrl}
              alt="Panel Caption"
            ></img>
          </div>
          <div className="expando-sidebar">
            <h3 className="expando-text expando-name">{name}</h3>
            <button className="expando-button">
              {collapsedText}
              <NonBreakingSpace />
              <FontAwesomeIcon icon={solid("angle-down")} />
            </button>
          </div>
        </div>
      </div>
    );
    //expanded
  } else if (isMobile && isOpen) {
    return (
      <div className="expando-open">
        {children}
        <button
          className="expando-button"
          onClick={() => {
            setIsOpen(false);
            sectionRef.current.scrollIntoView();
          }}
        >
          <FontAwesomeIcon icon={solid("angle-up")} />
          <NonBreakingSpace />
          {expandedText}
        </button>
      </div>
    );
  }
  //desktop
  else {
    return <>{children}</>;
  }
}

export default Expando;
